import Application from "shared/application";
import Dialog from "shared/dialog";
import $ from 'jquery';

/* global make_popup */
/* global log_error */

var Creative = {};

Creative.GET_HTML_DIALOG_ID = '#get_html';
Creative.POLLING_INTERVAL = 3 * 1000;
Creative.NUM_TIMES_TO_POLL = 10;
Creative.new_virtual_line_created = false;

Creative.initDialog = function() {
  $(Creative.GET_HTML_DIALOG_ID).modal({ show: false });

  Dialog.addButtons($(Creative.GET_HTML_DIALOG_ID),
    {
      'Done': function() { $(Creative.GET_HTML_DIALOG_ID).modal('hide'); }
    });
};

Creative.preview = function(id, html) {
  if (!html) {
    html = $("#" + id + "html").val();
  }

  var w = make_popup('', 'rr_preview_window', 'width=700,height=600');
  w.document.write("<!-- \n\
                      WARNING: This preview contains a special link for testing. Do not copy this code on to your site.\n\
                      The correct code for your site is shown in the textarea labeled 'HTML code' -->\n\
                     ");
  w.document.write("<fieldset><legend>Preview:</legend>");
  w.document.write("<div>" + html + "</div>");
  w.document.write("</fieldset>");
  w.document.close();

  // Chrome has known issues under certain environments that prevent dynamically created page content from
  // being painted. this forces a paint to occur after the window is open.
  // see: https://code.google.com/p/chromium/issues/detail?id=340138
  setTimeout(function() {
    $(w.document.body).find("div").append("&nbsp;");
  }, 100);
};

Creative.showHTMLDialog = function(content_url, extra_data) {
  var content = $(Creative.GET_HTML_DIALOG_ID).find('.get_html_content');

  content.html("<div class='loading_message' style='height: 250px;'>Loading...</div>").removeClass('color-error');
  $(Creative.GET_HTML_DIALOG_ID).modal('show');
  $(Creative.GET_HTML_DIALOG_ID).parent().find('.ui-dialog-buttonpane').hide();

  Application.ajax(
    {
      url: content_url,
      type: "GET",
      data: extra_data,
      success: function(data /*, textStatus */) {
        content.html(data);
        Creative.updateNewRowClass();
        Creative.toggleSettings();
        Creative.updateAllHTMLCode(Creative.GET_HTML_DIALOG_ID);
      },
      error_with_message: function(response, message) {
        content.html(message).addClass('color-error');
      },
      custom_error_handling: true
    });
};

Creative.showHTMLDialogWithCreative = function(content_url, creative_id) {
  var top_content  = $('#creative_dialog_' + creative_id);
  var lightbox     = $(Creative.GET_HTML_DIALOG_ID);
  var cached       = $(Creative.GET_HTML_DIALOG_ID + '_cached');

  lightbox.find('.creative_dialog_content > .creative_dialog').appendTo(cached);
  lightbox.find('.creative_dialog_content').append(top_content.show());

  Creative.showHTMLDialog(content_url, { advertiser_creative_id: creative_id });
};

Creative.toggleSettings = function() {
  var lightbox = $(Creative.GET_HTML_DIALOG_ID);

  // toggle settings
  if (lightbox.find('.get_html_content .settings_required').length == 0) {
    lightbox.find('.get_html_content .settings_row').hide();
  } else {
    lightbox.find('.get_html_content .settings_row').show();
  }
};

Creative.incrementPendingCount = function(advertiser_creative_id) {
  Creative.incrementCount(advertiser_creative_id, 'pending');
};

Creative.incrementCompletedCount = function(advertiser_creative_id) {
  Creative.incrementCount(advertiser_creative_id, 'completed');
};

Creative.incrementCount = function(advertiser_creative_id, type) {
  var count = parseInt($('.' + type + '_count_value_' + advertiser_creative_id).text());
  if (count >= 0) {
    $('.' + type + '_count_' + advertiser_creative_id).css('visibility', 'visible');
    $('.' + type + '_count_value_' + advertiser_creative_id).text(count + 1);
  }
};

Creative.getHTMLCode = function(vl_dom_id, creative_url, phone_number, creative_type, width, height, link_text, link_type_param) {
  /* This function generates the HTML for affiliates (and advertisers) to post promotions
   * It is called to generate clickable images for advertisers and affiliates, as well as text links
   * link_type_param = 'default' or 'preview'
   */

  var link_type  = link_type_param || 'default';
  var click_url  = Creative.getBaseClickURL(vl_dom_id, link_type, phone_number);

  var html_creative = "";
  var new_window = Creative.getSetting('new_window', Creative.GET_HTML_DIALOG_ID);
  var mobile_ctc = Creative.getSetting('mobile_ctc', Creative.GET_HTML_DIALOG_ID);
  var additional_params = Creative.getAdditionalParams('additional_params', Creative.GET_HTML_DIALOG_ID);

  if (creative_url) {
    switch (creative_type) {
    case 'image':
      html_creative += "<img src=\"" + creative_url + "\" alt=\"Call Now: " + phone_number + "\" border=\"0\"/>";
      break;
    case 'video':
      html_creative += '<iframe src="http://' + window.location.host + '/creatives/viewer/' + vl_dom_id.replace(/[A-z0-9_]+_/, '') + '?' +
                             (mobile_ctc ? "mobile=1&" : "") + (new_window ? "window_target=_blank" : "") +
                             '" width="' + width + '" height="' + height + '" frameborder="0" allowfullscreen>' +
                           '</iframe>';
      break;
    case 'flash':
      return "<object type=\"application/x-shockwave-flash\" data=\"" + creative_url + "\" width=\"" + width + "\" height=\"" + height + "\"><param name=\"movie\" value=\"" + creative_url + "\" /><param  name=\"flashvars\" value=\"clickTAG=" + escape(click_url) + "\" />Call Now: " + phone_number + "</object>";
    }
  } else {
    // user inputted text (for phone number links)
    html_creative += $('#' + vl_dom_id + 'body').val();
  }

  if (creative_type == 'text') {
    return link_text.replace(/<link>/g, Creative.buildLinkTag(click_url, { new_window: new_window, mobile_ctc: mobile_ctc, additional_params: additional_params })).replace(/<\/link>/g, "</a>");
  } else if (click_url && creative_type != 'video') {
    return Creative.buildLinkTag(click_url, { new_window: new_window, mobile_ctc: mobile_ctc, additional_params: additional_params }) + html_creative + "</a>";
  } else {
    return html_creative;
  }
};

Creative.getURL = function(vl_dom_id, link_type, phone_number) {
  var click_url  = Creative.getBaseClickURL(vl_dom_id, link_type, phone_number);

  var new_window = Creative.getSetting('new_window', Creative.GET_HTML_DIALOG_ID);
  var mobile_ctc = Creative.getSetting('mobile_ctc', Creative.GET_HTML_DIALOG_ID);
  var additional_params = Creative.getAdditionalParams('additional_params', Creative.GET_HTML_DIALOG_ID);
  return Creative.buildLink(click_url, { new_window: new_window, mobile_ctc: mobile_ctc, additional_params: additional_params });
};

Creative.getBaseClickURL = function(vl_dom_id, link_type, phone_number) {
  var click_urls = $('#' + vl_dom_id + "_click_url" + (link_type == 'preview' ? '_preview' : ''));

  if (click_urls.length == 0) {
    log_error("Click url not found for dom_id: " + vl_dom_id + ", phone: " + phone_number + ", link_type: " + link_type);
    return;
  }

  var click_url = click_urls.val();

  if (click_url.substr(0, 5) == 'PPCAN') {
    var dest = $(Creative.GET_HTML_DIALOG_ID).find('.html_setting_landing_page').val() || 'www.example.com';
    click_url = dest + (dest.indexOf('?') == -1 ? '?' : '&') + click_url;
  }

  return Creative.prependPortToURL(click_url);
};

Creative.buildLinkTag = function(url, options) {
  return "<a href=\"" + Creative.buildLink(url, options) + "\" target=\"" + (options['new_window'] ? "_blank" : "_top") + "\">";
};

Creative.buildLink = function(url, options) {
  return url + (options['additional_params'] ? Creative.parseAdditionalParams(options['additional_params']) : "") + (options['mobile_ctc'] ? "&mobile=1" : "");
};

Creative.parseAdditionalParams = function(params) {
  var output = '';
  var paramArray = params.split(",");

  for (var i = 0; i < paramArray.length; i++) {
    var param = paramArray[i];
    param = encodeURIComponent(param.trim());
    //    if last character of params is , or space, don't add it the &=
    if ((/[0-z]/).test(param) == true) {
      output += '&' + param + '=';
    }
  }

  return output;
};

Creative.updateHTMLCode = function(vl_dom_id, creative_url, phone_number, creative_type, width, height, link_text, link_type_param) {
  $("#" + vl_dom_id + "html").val(Creative.getHTMLCode(vl_dom_id, creative_url, phone_number, creative_type, width, height, link_text, link_type_param));
  $("#" + vl_dom_id + "url").val(Creative.getURL(vl_dom_id, link_type_param, phone_number));
};

Creative.updateAllHTMLCode = function(context) {
  $(context).find(".creative_html_container").each(function() {
    var div = $(this);
    var dom_id = div.find('input[name=creative_dom_id]').val();

    if (dom_id) {
      var creative_url = div.find('input[name=creative_url]').val();
      var phone_number = div.find('input[name=creative_phone_number]').val();
      var creative_type = div.find('input[name=creative_type]').val();
      var width = div.find('input[name=creative_width]').val();
      var height = div.find('input[name=creative_height]').val();
      var link_text = div.find('input[name=creative_link_text]').val();
      Creative.updateHTMLCode(dom_id, creative_url, phone_number, creative_type, width, height, link_text, 'default');
    }
  });
};

Creative.getSetting = function(name, context) {
  var setting;
  return (setting = $(context).find('.html_setting_' + name)[0]) && setting.checked;
};

Creative.getAdditionalParams = function(name, context) {
  return $(context).find('.html_setting_additional_params').val();
};

Creative.request_creative = function(owner_pk, advertiser_creative_id, virtual_line_id, virtual_line_number, container, creative_type) {
  $("#requested_virtual_line_id").val(virtual_line_id);
  $("#requested_virtual_line_number").val(virtual_line_number);
  $("#requested_creative_type").val(creative_type);

  Creative.add_phone(owner_pk, advertiser_creative_id, container, virtual_line_id, creative_type);
};

Creative.get_request_row = function(advertiser_creative_id, virtual_line_id) {
  return $('#virtual_line_creative_request_row_' + advertiser_creative_id + '_' + virtual_line_id);
};

Creative.add_phone = function(owner_pk, advertiser_creative_id, container, virtual_line_id, creative_type) {
  // make sure it's open (was closed in the shipping_address dialog code path
  $(Creative.GET_HTML_DIALOG_ID).modal('show');

  $("#request_creative_" + advertiser_creative_id + '_' + virtual_line_id).hide();
  $("#request_creative_message_" + advertiser_creative_id + '_' + virtual_line_id).hide();
  $("#request_creative_loading_" + advertiser_creative_id + '_' + virtual_line_id).show();

  var form = $("form#creative_request_form");
  if (form.length == 0) {
    log_error("Download_creative.add_phone: No creative request form found.");
    Creative.show_message(advertiser_creative_id, virtual_line_id, "Sorry, an error occurred", true);
    return;
  }

  var form_data = [];
  form_data.push({ name: 'owner', value: owner_pk });
  form_data.push({ name: 'advertiser_creative_id', value: advertiser_creative_id });
  form_data.push({ name: 'ajax', value: 1 });
  form_data.push({ name: 'format', value: 'html' });

  var media_type_field =  null;
  var description_field = null;

  if (virtual_line_id == 'new') {
    media_type_field = Creative.get_request_row(advertiser_creative_id, virtual_line_id).find("select[name='virtual_line[media_type]']");
    description_field = Creative.get_request_row(advertiser_creative_id, virtual_line_id).find("input[name='virtual_line[description]']");

    form_data.push({ name: 'virtual_line[media_type]', value: media_type_field.val() });
    form_data.push({ name: 'virtual_line[description]', value: description_field.val() });
  } else {
    form_data.push({ name: 'virtual_line_id', value: virtual_line_id });
  }

  Application.ajax(
    {
      url: form[0].action,
      type: "POST",
      data: form_data,
      success: function(data /*, textStatus */) {
        if (data.redirect) {
          Creative.setup_polling(advertiser_creative_id, virtual_line_id);
          setTimeout(function() { Creative.add_phone_polling(Creative.NUM_TIMES_TO_POLL, data.redirect, container, advertiser_creative_id, virtual_line_id, true); },
            Creative.POLLING_INTERVAL);
          return;
        }

        var content = $(data);

        Creative.add_phone_on_success(container, advertiser_creative_id, virtual_line_id, content);

        Creative.updateNewRowClass();
        Creative.toggleSettings();
        if (creative_type == 'Text' || creative_type == 'OnlineVideo') {
          Creative.incrementCompletedCount(advertiser_creative_id);
        } else {
          Creative.incrementPendingCount(advertiser_creative_id);
        }

        $(Creative.GET_HTML_DIALOG_ID).find('.no_virtual_lines_content').hide();

        // initialize and show tooltip if it exists
        var triggers = content.find(".tooltip_trigger_pending");

        if (triggers.length > 0) {
          triggers.tooltip_deprecated({ relative: true, position: ['bottom', 'left'] });
          triggers.data("tooltip").show();
        }
      },
      error_with_message: function(response, message, text_status, status) {
        $("#request_creative_" + advertiser_creative_id + '_' + virtual_line_id).show();
        $("#request_creative_loading_" + advertiser_creative_id + '_' + virtual_line_id).hide();
        Creative.show_error_response(advertiser_creative_id, message);
        Creative.scrollToBottom();
      },
      custom_error_handling: true
    });
};

Creative.setup_polling = function(advertiser_creative_id, virtual_line_id) {
  $("#request_creative_loading_" + advertiser_creative_id + '_' + virtual_line_id).show();
  $("#request_creative_message_" + advertiser_creative_id + '_' + virtual_line_id).show().removeClass('color-error').text('Processing image...');
};

Creative.add_phone_polling = function(times_left, url, container, advertiser_creative_id, virtual_line_id, allow_retry) {
  if (times_left <= 0) {
    var html = "Timed out processing image.";
    if (allow_retry) {
      html += " <a href=\"#\" onclick=\"Creative.setup_polling( " + advertiser_creative_id + ", '" + virtual_line_id + "' ); Creative.add_phone_polling( Creative.NUM_TIMES_TO_POLL, '" + url + "', '" + container + "', " + advertiser_creative_id + ", '" + virtual_line_id + "', false ); return false;\">Check again.</a>";
      log_error("Timed out waiting for image processing. advertiser_creative_id: " + advertiser_creative_id + ", virtual line id: " + virtual_line_id);
    } else {
      html += " Please check back later.";
    }
    $("#request_creative_loading_" + advertiser_creative_id + '_' + virtual_line_id).hide();
    $("#request_creative_message_" + advertiser_creative_id + '_' + virtual_line_id).show().addClass('color-error').html(html);
    return;
  }

  // update count on complete;
  Application.ajax(
    {
      url: url,
      type: "GET",
      success: function(data /*, textStatus */) {
        if (data.redirect) {
          setTimeout(function() { Creative.add_phone_polling(times_left - 1, data.redirect, container, advertiser_creative_id, virtual_line_id, allow_retry); },
            Creative.POLLING_INTERVAL);
          return;
        }

        Creative.add_phone_on_success(container, advertiser_creative_id, virtual_line_id, $(data));

        Creative.updateNewRowClass();
        Creative.toggleSettings();
        Creative.incrementCompletedCount(advertiser_creative_id);

        $(Creative.GET_HTML_DIALOG_ID).find('.no_virtual_lines_content').hide();

        // relook up element (even though it was inserted using $ apis above), because otherwise Chrome/Safari throws an error during highlight effect
        var row = $('#virtual_line_creative_request_row_' + advertiser_creative_id + '_' + virtual_line_id);
        if (virtual_line_id == 'new') {
          row = row.prev();
        }
        row.effect('highlight', {}, 3000);
      },
      error_with_message: function(response, message, text_status, status) {
        $("#request_creative_loading_" + advertiser_creative_id + '_' + virtual_line_id).hide();
        $("#request_creative_message_" + advertiser_creative_id + '_' + virtual_line_id).show().addClass('color-error').text('Sorry, an error occurred');
      },
      custom_error_handling: true
    });
};

Creative.add_phone_on_success = function(container, advertiser_creative_id, virtual_line_id, content) {
  var media_type_field  = Creative.get_request_row(advertiser_creative_id, virtual_line_id).find("select[name='virtual_line[media_type]']");
  var description_field = Creative.get_request_row(advertiser_creative_id, virtual_line_id).find("input[name='virtual_line[description]']");

  if (virtual_line_id == 'new') {
    $(container).before(content);

    // reset fields
    media_type_field.val('Please select media type');
    description_field.val('');
    $("#request_creative_" + advertiser_creative_id + '_' + virtual_line_id).show();
    $("#request_creative_loading_" + advertiser_creative_id + '_' + virtual_line_id).hide();
    $("#request_creative_message_" + advertiser_creative_id + '_' + virtual_line_id).hide();

    Creative.show_message(advertiser_creative_id, virtual_line_id, '');

    Creative.hideNewNumberForm($(container).parent().parent());
    Creative.scrollToBottom();
  } else {
    $(container).replaceWith(content);
  }
};

Creative.show_message = function(suffix1, suffix2, message, error) {
  var status = $("#status_message_" + suffix1 + '_' + suffix2).show().html(message);

  if (error) {
    status.addClass('color-error');
  } else {
    status.removeClass('color-error');
  }
};

Creative.show_error_response = function(suffix, message) {
  var creative_type       = $('#requested_creative_type').val();
  var virtual_line_id     = $('#requested_virtual_line_id').val();
  var virtual_line_number = $('#requested_virtual_line_number').val();

  Creative.show_message(suffix, virtual_line_id, message, true);
};

Creative.toggleHelp = function(user_id) {
  if ($("#creatives_help_container").is(":visible")) {
    $("#show_hide_help").text("Show help");
    Creative.hideHelp(user_id);
  } else {
    $("#show_hide_help").text("Hide help");
    Creative.showHelp(user_id);
  }
};

Creative.hideHelp = function(user_id) {
  $('#creatives_help_container').slideUp();
  $('#show_hide_help').fadeIn();

  Creative.saveCreativeFlag(user_id, 0);
};

Creative.showHelp = function(user_id) {
  if ($('#creative_request_drawer').is(":visible")) {
    $("#view_creative_requests_link span:not(.count)").text("View Requests");
    $('#creative_request_drawer').slideUp(function() {
      $('#creatives_help_container').slideDown();
      Creative.saveCreativeFlag(user_id, 1);
    });
  } else {
    $('#creatives_help_container').slideDown();
    Creative.saveCreativeFlag(user_id, 1);
  }
};

Creative.saveCreativeFlag = function(user_id, value) {
  Application.ajax(
    {
      url: '/users/update/' + user_id,
      type: "POST",
      data: { ajax: 1,
        format: 'json',
        'user[show_creatives_help]': value },
      error_with_message: function(/* response, message */) {
        // don't show to user. Rely on server exceptions
      },
      custom_error_handling: true
    });
};

Creative.updateNewRowClass = function() {
  var content = $(Creative.GET_HTML_DIALOG_ID).find('.get_html_content');

  content.find('.request_row:odd').addClass('oddTableRow').removeClass('evenTableRow');
  content.find('.request_row:even').addClass('evenTableRow').removeClass('oddTableRow');

  if (content.find('.request_row:last').hasClass('oddTableRow')) {
    $(Creative.GET_HTML_DIALOG_ID).find('.new_virtual_line_row').addClass('evenTableRow').removeClass('oddTableRow');
  } else {
    $(Creative.GET_HTML_DIALOG_ID).find('.new_virtual_line_row').addClass('oddTableRow').removeClass('evenTableRow');
  }
};

Creative.showNewNumberForm = function(container) {
  $(container).find('.new_virtual_line_row').show();
  $(container).find('.new_virtual_line_button').hide();

  Creative.scrollToBottom();
};

Creative.hideNewNumberForm = function(container) {
  $(container).find('.new_virtual_line_row').hide();
  $(container).find('.new_virtual_line_button').show();

  Creative.scrollToBottom();
};

Creative.scrollToBottom = function(container) {
  $(Creative.GET_HTML_DIALOG_ID)[0].scrollTop = $(Creative.GET_HTML_DIALOG_ID).height();
};

/* Search link functions */
Creative.updateSearchLink = function(container, click_url_prefix) {
  var mobile_ctc = Creative.getSetting('mobile_ctc', container);
  var url        = $(container).find(click_url_prefix + "_textarea");
  var cache      = $(container).find(click_url_prefix + "_cache");

  if (url.val()) {
    // one-time, store aside original URL
    if (!cache.val()) {
      cache.val(url.val());
    }

    url.val(cache.val() + (mobile_ctc ? "&mobile=1" : ""));
  }
};

Creative.prependPortToURL = function(url) {
  if (url && url.search(/^http[s]?:\/\//) == -1) {
    url = 'http://' + url;
  }

  return url;
};
// Creative Type Requests
Creative.affiliateToggleRequestDrawer = function() {
  if ($('#creative_request_drawer').is(":visible")) {
    Creative.hideRequestDrawer();
    $("#view_creative_requests_link span:not(.count)").text("View Requests");
  } else {
    Creative.showRequestDrawer();
    $("#view_creative_requests_link span:not(.count)").text("Hide Requests");
  }
};

Creative.showRequestDrawer = function() {
  if ($('#creatives_help_container').is(':visible')) {
    $("#show_hide_help").text("Show help");
    $('#creatives_help_container').slideUp(function() {
      $('#creative_request_drawer').slideDown();
    });
  } else {
    $('#creative_request_drawer').slideDown();
  }
  $("#creative_request_drawer table tbody tr.hoverable").die('click');
  $("#creative_request_drawer table tbody tr.hoverable").live('click', function() {
    $(this).find(".arrow").toggleClass("opened_arrow");
    $(this).toggleClass('collapsed');
    if ($(this).is(".unread")) {
      if (!Creative.OBSERVER) {
        Creative.ackCreativeRequest(this);
      }
    }
    return false;
  });
};
Creative.hideRequestDrawer = function() {
  $('#creative_request_drawer').slideUp();
  $("#creative_request_drawer table tbody tr.hoverable").die('click');
};

Creative.showRequestDialog = function() {
  Dialog.ModalPrompt.show(
    {
      title: "Request Creative Type",
      buttons: {
        Cancel: function() { Dialog.ModalPrompt.close(); },
        OK: function() {
          var request_text = Dialog.ModalPrompt.getMessage;
          Dialog.ModalPrompt.clearStatus();
          Creative.requestCreative(request_text,
            function(data, textStatus) {
              Creative.insertCreativeRequest(data);
              $(Dialog.ModalPrompt.SELECTOR).modal('hide');
              Creative.showRequestDrawer();
            },
            function(response, message) {
              // error
              Dialog.ModalPrompt.setStatus(message, true);
            });
        }
      }
    });

  var label = "Type a message to the " + Invoca.Config.localization.advertiserNameFromNetwork.toString().toLowerCase() +
        " requesting additional creative.<br />Please specify the exact dimensions and where the creative will be used.";

  Dialog.ModalPrompt.setLabel(label);
  Dialog.ModalPrompt.setMessage('');
};

Creative.CREATIVE_REQUEST_URL = null;
Creative.CREATIVE_REQUEST_AFC_ID = null;
Creative.UNREAD_CREATIVE_REQUEST_COUNT = null;
Creative.OBSERVER = false;
Creative.requestCreative = function(request_text, success_callback, error_callback) {
  Application.ajax({ url: Creative.CREATIVE_REQUEST_URL,
    type: "POST",
    data: { ajax: 1,
      format: 'html',
      id: Creative.CREATIVE_REQUEST_AFC_ID,
      request_notes: request_text
    },
    custom_error_handling: true,
    success: success_callback,
    error_with_message: error_callback
  });
};

Creative.insertCreativeRequest = function(html) {
  $("#no_pending_requests_row").remove();
  $("#creative_request_drawer > table > tbody").prepend(html);
};
Creative.ackCreativeRequest = function(row) {
  row = $(row);
  var cr_id = row.children('.creative_request_id').text();
  Application.ajax({
    url: Creative.CREATIVE_REQUEST_URL,
    type: "POST",
    data: {
      ajax: 1,
      format: 'json',
      id: Creative.CREATIVE_REQUEST_AFC_ID,
      ack_cr_id: cr_id
    },
    success: function() {
      row.removeClass('bold');
      row.removeClass('unread');
      Creative.UNREAD_CREATIVE_REQUEST_COUNT = $("#creative_request_table .creative_request_row.unread").length;
      $("#view_creative_requests_link .count").text('(' + Creative.UNREAD_CREATIVE_REQUEST_COUNT + ')');
      if (Creative.UNREAD_CREATIVE_REQUEST_COUNT == 0) {
        $("#view_creative_requests_link .count").remove();
      }
    }
  });
};

export default Creative;
